import React from "react";
import "../Agriculture.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { NavLink } from "react-router-dom";

import {
    FiHome,
    FiChevronRight,
    FiSun,
} from "react-icons/fi";


const Agriculture = () => {

    return (

        <>

            <Header />


            <section className="agriculture-hero">

                <div className="agriculture-overlay"></div>


                <div className="container">


                    <div className="agriculture-hero-content">


                        <span className="agriculture-tag">

                            Agriculture Technology Solutions

                        </span>


                        <h1>

                            Transforming
                            <span> Agriculture </span>
                            Through Smart Digital Innovation

                        </h1>


                        <p>

                            Kishancart Digital (OPC) Private Limited empowers
                            farmers, agriculture businesses, food suppliers,
                            and agritech organizations with innovative digital
                            solutions. We develop smart agriculture platforms
                            that improve farm management, optimize resources,
                            enhance productivity, automate operations, and
                            enable data-driven decision making for modern
                            farming.

                        </p>


                        <div className="agriculture-hero-btns">


                            {/* Buttons can be added here */}

                            {/*

                            <NavLink
                                to="/contact"
                                className="primary-btn"
                            >
                                Contact Us
                            </NavLink>


                            <NavLink
                                to="/services"
                                className="secondary-btn"
                            >
                                Explore Services
                            </NavLink>

                            */}


                        </div>


                    </div>


                </div>


            </section>


            <section className="agriculture-breadcrumb">

              <div className="container">


                    <div className="breadcrumb">


                        <NavLink to="/">

                            <FiHome />

                            Home

                        </NavLink>



                        <FiChevronRight />



                        <span>

                            Solutions

                        </span>



                        <FiChevronRight />



                        <span className="active">


                            <FiSun />

                            Agriculture


                        </span>



                    </div>


                </div>

            </section>


            <section className="agriculture-overview">

                <div className="container">



                    <div className="overview-grid">



                        {/* LEFT CONTENT */}



                        <div className="overview-content">


                            <span className="section-tag">

                                Digital Agriculture Solutions

                            </span>



                            <h2>

                                Smart Technology for
                                <span> Modern Farming</span>

                            </h2>



                            <p>

                                Kishancart Digital (OPC) Private Limited
                                develops secure and scalable agriculture
                                technology solutions that help farmers,
                                agriculture companies, and agribusinesses
                                improve productivity, optimize resources,
                                and manage farming operations efficiently.

                            </p>



                            <p>

                                Our digital agriculture platforms enable
                                smart farm management, crop monitoring,
                                inventory management, supply chain
                                coordination, and real-time analytics.
                                We help agriculture organizations adopt
                                modern technologies to build sustainable
                                and efficient farming ecosystems.

                            </p>




                            <div className="overview-list">



                                <div className="overview-item">

                                    ✓ Smart Farm Management System

                                </div>



                                <div className="overview-item">

                                    ✓ Crop Monitoring & Analytics

                                </div>



                                <div className="overview-item">

                                    ✓ Agriculture Inventory Management

                                </div>



                                <div className="overview-item">

                                    ✓ Supply Chain Management

                                </div>



                                <div className="overview-item">

                                    ✓ Farmer Mobile Applications

                                </div>



                                <div className="overview-item">

                                    ✓ IoT Based Agriculture Solutions

                                </div>



                            </div>



                        </div>






                        {/* RIGHT CARDS */}





                        <div className="overview-cards">





                            <div className="overview-card">


                                <h3>

                                    Smart Farm Management

                                </h3>


                                <p>

                                    Manage farming activities, crop cycles,
                                    resources, and field operations through
                                    a centralized digital platform.

                                </p>


                            </div>






                            <div className="overview-card">


                                <h3>

                                    Crop Monitoring

                                </h3>


                                <p>

                                    Monitor crop health, weather conditions,
                                    irrigation requirements, and farming
                                    performance using digital technologies.

                                </p>


                            </div>






                            <div className="overview-card">


                                <h3>

                                    Agriculture Automation

                                </h3>


                                <p>

                                    Automate farming workflows including
                                    inventory tracking, resource planning,
                                    reporting, and operational management.

                                </p>


                            </div>






                            <div className="overview-card">


                                <h3>

                                    Agriculture Analytics

                                </h3>


                                <p>

                                    Analyze farm data, production trends,
                                    resource utilization, and business
                                    performance with real-time dashboards.

                                </p>


                            </div>





                        </div>



                    </div>



                </div>



            </section>


                        {/* =====================================================
                    AGRICULTURE CHALLENGES
            ===================================================== */}


            <section className="agriculture-challenges">


                <div className="container">


                    <div className="section-heading">


                        <span className="section-tag">

                            Industry Challenges

                        </span>



                        <h2>

                            Challenges in
                            <span> Modern Agriculture Management</span>

                        </h2>



                        <p>

                            Agriculture organizations face challenges related
                            to productivity, resource management, weather
                            uncertainty, supply chain efficiency, and
                            operational visibility. Our digital agriculture
                            solutions help overcome these challenges with
                            modern technology.

                        </p>



                    </div>





                    <div className="challenge-grid">



                        <div className="challenge-card">


                            <h3>

                                Farm Management

                            </h3>


                            <p>

                                Manage farming activities, crop planning,
                                field operations, and resources efficiently
                                through an integrated digital platform.

                            </p>


                        </div>





                        <div className="challenge-card">


                            <h3>

                                Crop Monitoring

                            </h3>


                            <p>

                                Track crop health, growth conditions,
                                irrigation requirements, and farming
                                performance using smart monitoring systems.

                            </p>


                        </div>






                        <div className="challenge-card">


                            <h3>

                                Resource Optimization

                            </h3>


                            <p>

                                Optimize water usage, fertilizers, seeds,
                                equipment, and other agricultural resources
                                to improve productivity.

                            </p>


                        </div>






                        <div className="challenge-card">


                            <h3>

                                Supply Chain Management

                            </h3>


                            <p>

                                Improve agriculture supply chain visibility
                                from production and storage to distribution
                                with digital management solutions.

                            </p>


                        </div>






                        <div className="challenge-card">


                            <h3>

                                Weather & Climate Impact

                            </h3>


                            <p>

                                Use real-time data and analytics to monitor
                                weather conditions and make better farming
                                decisions.

                            </p>


                        </div>






                        <div className="challenge-card">


                            <h3>

                                Data Management

                            </h3>


                            <p>

                                Securely collect, organize, and analyze
                                agricultural data to improve planning,
                                forecasting, and decision making.

                            </p>


                        </div>





                    </div>



                </div>


            </section>







            {/* =====================================================
                    OUR AGRICULTURE SOLUTIONS
            ===================================================== */}



            <section className="agriculture-solutions">


                <div className="container">



                    <div className="section-heading">


                        <span className="section-tag">

                            Our Agriculture Solutions

                        </span>




                        <h2>

                            Comprehensive Digital Solutions for
                            <span> Agriculture Industry</span>

                        </h2>




                        <p>

                            We develop smart, scalable, and technology-driven
                            agriculture solutions that help farmers,
                            agribusinesses, and agriculture organizations
                            improve efficiency, productivity, and sustainable
                            growth.

                        </p>



                    </div>






                    <div className="solutions-grid">





                        <div className="solution-card">


                            <h3>

                                Smart Farm Management System

                            </h3>


                            <p>

                                Digitally manage farm activities, crop
                                planning, field operations, resources, and
                                farming records from one centralized platform.

                            </p>


                        </div>






                        <div className="solution-card">


                            <h3>

                                Precision Agriculture

                            </h3>


                            <p>

                                Use data-driven insights, sensors, and
                                analytics to improve crop productivity and
                                optimize agricultural resources.

                            </p>


                        </div>






                        <div className="solution-card">


                            <h3>

                                IoT Agriculture Solutions

                            </h3>


                            <p>

                                Monitor soil conditions, weather data,
                                irrigation systems, and farm environments
                                through connected smart devices.

                            </p>


                        </div>






                        <div className="solution-card">


                            <h3>

                                Crop Monitoring Platform

                            </h3>


                            <p>

                                Track crop growth, health status, farming
                                activities, and production performance with
                                real-time monitoring.

                            </p>


                        </div>






                        <div className="solution-card">


                            <h3>

                                Agriculture Inventory Management

                            </h3>


                            <p>

                                Manage seeds, fertilizers, equipment,
                                pesticides, and agricultural stock with
                                automated inventory solutions.

                            </p>


                        </div>






                        <div className="solution-card">


                            <h3>

                                Farmer Mobile Application

                            </h3>


                            <p>

                                Provide farmers with mobile access to crop
                                information, weather updates, market data,
                                and digital farming services.

                            </p>


                        </div>






                        <div className="solution-card">


                            <h3>

                                Agriculture Marketplace

                            </h3>


                            <p>

                                Connect farmers, suppliers, and buyers through
                                digital marketplaces for efficient agriculture
                                trade and communication.

                            </p>


                        </div>






                        <div className="solution-card">


                            <h3>

                                Agriculture Analytics Dashboard

                            </h3>


                            <p>

                                Analyze farming data, production reports,
                                resource usage, and business performance with
                                real-time dashboards.

                            </p>


                        </div>





                    </div>



                </div>


            </section>

                        {/* =====================================================
                    AGRICULTURE FEATURES
            ===================================================== */}


            <section className="healthcare-features">


                <div className="container">



                    <div className="section-heading">


                        <span className="section-tag">

                            Key Features

                        </span>




                        <h2>

                            Everything Needed for a
                            <span> Modern Agriculture Platform</span>

                        </h2>




                        <p>

                            Our agriculture technology solutions include
                            powerful features designed to improve farming
                            productivity, simplify operations, and support
                            data-driven agricultural decisions.

                        </p>



                    </div>






                    <div className="features-grid">





                        <div className="feature-card">

                            <h3>

                                Smart Farm Monitoring

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Crop Health Tracking

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Weather Monitoring

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Soil Analysis Management

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Irrigation Management

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Farm Inventory Management

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Farmer Mobile Application

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Digital Agriculture Marketplace

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Supply Chain Tracking

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Agriculture Reports & Analytics

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Multi-Farm Management

                            </h3>

                        </div>





                        <div className="feature-card">

                            <h3>

                                Secure Cloud Platform

                            </h3>

                        </div>





                    </div>



                </div>



            </section>









            {/* =====================================================
                    BUSINESS BENEFITS
            ===================================================== */}



            <section className="agriculture-benefits">


                <div className="container">



                    <div className="section-heading">


                        <span className="section-tag">

                            Business Benefits

                        </span>




                        <h2>

                            Why Agriculture Organizations Choose
                            <span> Kishancart Digital</span>

                        </h2>




                        <p>

                            Our agriculture technology solutions help farmers,
                            agribusinesses, and agriculture organizations
                            improve productivity, reduce operational costs,
                            optimize resources, and build sustainable digital
                            farming ecosystems.

                        </p>



                    </div>







                    <div className="benefits-grid">





                        <div className="benefit-card">


                            <h3>

                                Increased Farming Productivity

                            </h3>


                            <p>

                                Improve crop production and farming efficiency
                                through smart monitoring, analytics, and
                                technology-driven agriculture solutions.

                            </p>


                        </div>







                        <div className="benefit-card">


                            <h3>

                                Better Resource Management

                            </h3>


                            <p>

                                Optimize water, fertilizers, seeds, equipment,
                                and other agricultural resources to reduce
                                waste and improve efficiency.

                            </p>


                        </div>







                        <div className="benefit-card">


                            <h3>

                                Data-Driven Decisions

                            </h3>


                            <p>

                                Make accurate farming decisions using real-time
                                agriculture data, reports, analytics, and
                                predictive insights.

                            </p>


                        </div>







                        <div className="benefit-card">


                            <h3>

                                Reduced Operational Costs

                            </h3>


                            <p>

                                Automate farming operations, inventory,
                                reporting, and management processes to reduce
                                manual efforts and expenses.

                            </p>


                        </div>







                        <div className="benefit-card">


                            <h3>

                                Scalable Agriculture Platform

                            </h3>


                            <p>

                                Easily expand digital agriculture services
                                across multiple farms, locations, and
                                agricultural businesses.

                            </p>


                        </div>







                        <div className="benefit-card">


                            <h3>

                                Future-Ready Smart Farming

                            </h3>


                            <p>

                                Adopt modern technologies including IoT,
                                automation, cloud computing, and analytics
                                for sustainable agriculture growth.

                            </p>


                        </div>





                    </div>




                </div>



            </section>






            <Footer />


        </>

    );

};


export default Agriculture;